export const scoreConfig_AllergyandEczema_thai = [
    {
        titel: `Asthma`,
        match_key: 'Asthma',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 867,
        Xtextpos: 642,
        Ytextpos: 873,
        formula: 'static_asthma_score',
        page: 15,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            'Candida albicans',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Lactobacillus plantarum',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `Asthma`,
        match_key: 'Asthma',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 17,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            'Candida albicans',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Lactobacillus plantarum',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `Eczema`,
        match_key: 'Eczema',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 18,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Escherichia coli',
            'Staphylococcus aureus',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Lactobacillus acidophilus',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Food allergy page 12
        titel: `Food allergy`,
        match_key: 'Food allergy',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 19,
        value_use: [
            'Bacteroidetes phylum',
            'Bacteroides genus',
            'Bacteroides fragilis',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus plantarum',
            'Streptococcus thermophilus'

          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `Food allergy`,
        match_key: 'Food allergy',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 1020,
        Xtextpos: 642,
        Ytextpos: 1026,
        formula: 'static_asthma_score',
        page: 15,
        value_use: [
            'Bacteroidetes phylum',
            'Bacteroides genus',
            'Bacteroides fragilis',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus plantarum',
            'Streptococcus thermophilus'

          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `Eczema`,
        match_key: 'Eczema',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 945,
        Xtextpos: 642,
        Ytextpos: 951,
        formula: 'static_asthma_score',
        page: 15,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Escherichia coli',
            'Staphylococcus aureus',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Lactobacillus acidophilus',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    // {
    //     // Food Eczema page 15
    //     titel: `Eczema`,
    //     match_key: 'Eczema',
    //     Xdotpos: 177,
    //     Ydotpos: 275,
    //     Xnumberpos: 580,
    //     Ynumberpos: 250,
    //     formula: 'static_asthma_score',
    //     max_dot: 10,
    //     page: 15,
    //     value_use: [
    //         'Faecalibacterium prausnitzii',
    //         'Escherichia coli',
    //         'Staphylococcus aureus',
    //         'Bifidobacterium bifidum',
    //         'Bifidobacterium breve',
    //         'Lactobacillus acidophilus',
    //         'Lactobacillus rhamnosus'
    //       ],
    //     table_socre: [
    //         {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
    //         {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
    //         {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
    //     ]
    // },
    {
        titel: `Allergic rhinitis`,
        match_key: 'Allergic rhinitis',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 788,
        Xtextpos: 642,
        Ytextpos: 795,
        formula: 'static_asthma_score',
        page: 15,
        value_use: [
            'Bifidobacterium breve',
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Food Allergic rhinitis page 16
        titel: `Allergic rhinitis`,
        match_key: 'Allergic rhinitis',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 16,
        value_use: [
            'Bifidobacterium breve',
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `Overweight`,
        match_key: 'Overweight',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 266,
        Xtextpos: 642,
        Ytextpos: 272,
        formula: 'static_asthma_score',
        page: 21,
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroidetes phylum',
            'Bacteroides genus',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Metabolic syndrome page 18
        titel: ['Metabolic', 'syndrome'],
        match_key: 'Metabolic syndrome',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 110,
        Xtextpos: 642,
        Ytextpos: 118,
        formula: 'static_asthma_score',
        page: 21,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium lactis',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Metabolic syndrome page 20
        titel: `['Metabolic', 'syndrome']`,
        match_key: 'Metabolic syndrome',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 22,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium lactis',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Type 2 diabetes page 18
        titel: `['Type 2', 'diabetes']`,
        match_key: 'Type 2 diabetes',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 345,
        Xtextpos: 642,
        Ytextpos: 352,
        formula: 'static_asthma_score',
        page: 21,
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroides fragilis',
            'Faecalibacterium prausnitzii',
            'Bacillus genus',
            'Candida albicans',
            ' Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `['Type 2', 'diabetes']`,
        match_key: 'Type 2 diabetes',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 26,
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroides fragilis',
            'Faecalibacterium prausnitzii',
            'Bacillus genus',
            'Candida albicans',
            ' Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `['Excessive', 'lipopolysaccharide']`,
        match_key: 'Excessive lipopolysaccharide',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 190,
        Xtextpos: 642,
        Ytextpos: 196,
        formula: 'static_asthma_score',
        page: 21,
        value_use: [
            'Akkermansia muciniphila',
            'Bifidobacterium bifidum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Excessive lipopolysaccharide page 22
        titel: `['Excessive', 'lipopolysaccharide']`,
        match_key: 'Excessive lipopolysaccharide',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 23,
        value_use: [
            'Akkermansia muciniphila',
            'Bifidobacterium bifidum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `Overweight`,
        match_key: 'Overweight',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 24,
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroidetes phylum',
            'Bacteroides genus',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `Constipation`,
        match_key: 'Constipation',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 112,
        Xtextpos: 642,
        Ytextpos: 118,
        formula: 'static_asthma_score',
        page: 29,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Staphylococcus aureus',
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `Constipation`,
        match_key: 'Constipation',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 420,
        Xtextpos: 642,
        Ytextpos: 427,
        formula: 'static_asthma_score',
        page: 29,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Staphylococcus aureus',
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    // {
    //     // Constipation page 23
    //     titel: `Constipation`,
    //     match_key: 'Constipation',
    //     Xdotpos: 177,
    //     Ydotpos: 275,
    //     Xnumberpos: 580,
    //     Ynumberpos: 248,
    //     formula: 'static_asthma_score',
    //     max_dot: 10,
    //     page: 24,
    //     value_use: [
    //         'Faecalibacterium prausnitzii',
    //         'Staphylococcus aureus',
    //         'Bifidobacterium lactis',
    //         'Bifidobacterium longum',
    //         'Lactobacillus acidophilus',
    //         'Lactobacillus paracasei',
    //         'Lactobacillus plantarum',
    //         'Lactobacillus rhamnosus'
    //       ],
    //     table_socre: [
    //         {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
    //         {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
    //         {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
    //     ]
    // },
    {
        // Diarrhea page 23
        titel: `Diarrhea`,
        match_key: 'Diarrhea',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 188,
        Xtextpos: 642,
        Ytextpos: 195,
        formula: 'static_asthma_score',
        page: 29,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Roseburia hominis',
            'Bacillus genus',
            'Candida albicans',
            'Clostridium difficile',
            'Escherichia coli',
            'Staphylococcus aureus',
            'Lactobacillus reuteri',
            'Lactobacillus rhamnosus',
            'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        titel: `Diarrhea`,
        match_key: 'Diarrhea',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 31,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Roseburia hominis',
            'Bacillus genus',
            'Candida albicans',
            'Clostridium difficile',
            'Escherichia coli',
            'Staphylococcus aureus',
            'Lactobacillus reuteri',
            'Lactobacillus rhamnosus',
            'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Immune disorder page 23
        titel: `Immune disorder`,
        match_key: 'Immune disorder',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 33,
        value_use: [
            'Alistipes putredinis',
            'Roseburia hominis',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus helveticus',
            'Lactobacillus paracasei',
            'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Immune disorder page 26
        titel: `Immune disorder`,
        match_key: 'Immune disorder',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 266,
        Xtextpos: 642,
        Ytextpos: 273,
        formula: 'static_asthma_score',
        page: 29,
        value_use: [
            'Alistipes putredinis',
            'Roseburia hominis',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus helveticus',
            'Lactobacillus paracasei',
            'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Insomnia/ poor sleep page 27
        titel: `['Insomnia/ poor', 'sleep quality']`,
        match_key: 'Insomnia/ poor sleep quality',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 37,
        value_use: [
            'Alistipes putredinis',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Insomnia/ poor sleep page 27
        titel: `['Insomnia/ poor', 'sleep quality']`,
        match_key: 'Insomnia/ poor sleep quality',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 900,
        Xtextpos: 642,
        Ytextpos: 907,
        formula: 'static_asthma_score',
        page: 35,
        value_use: [
            'Alistipes putredinis',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Stress and anxiety page 27
        titel: `['Stress and', 'anxiety']`,
        match_key: 'Stress and anxiety',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 824,
        Xtextpos: 642,
        Ytextpos: 831,
        formula: 'static_asthma_score',
        page: 35,
        value_use: [
            'Akkermansia muciniphila',
            'Candida albicans',
            'Bifidobacterium bifidum',
            'Lactobacillus helveticus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    {
        // Stress and anxiety page 27
        titel: `['Stress and', 'anxiety']`,
        match_key: 'Stress and anxiety',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 165,
        Xtextpos: 642,
        Ytextpos: 171,
        formula: 'static_asthma_score',
        page: 36,
        value_use: [
            'Akkermansia muciniphila',
            'Candida albicans',
            'Bifidobacterium bifidum',
            'Lactobacillus helveticus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
        ]
    },
    // {
    //     // Stress and anxiety page 29
    //     titel: `['Stress and', 'anxiety']`,
    //     match_key: 'Stress and anxiety',
    //     Xdotpos: 177,
    //     Ydotpos: 275,
    //     Xnumberpos: 580,
    //     Ynumberpos: 248,
    //     formula: 'static_asthma_score',
    //     max_dot: 10,
    //     page: 29,
    //     value_use: [
    //         'Akkermansia muciniphila',
    //         'Candida albicans',
    //         'Bifidobacterium bifidum',
    //         'Lactobacillus helveticus'
    //       ],
    //     table_socre: [
    //         {min: 0, max: 3, color_dot: '#8bcc2c', label: 'ต่ำ'},
    //         {min: 4, max: 6, color_dot: '#fa891f',label: 'ปานกลาง'},
    //         {min: 7, max: 10, color_dot: '#fa1f1f', label: 'สูง'}
    //     ]
    // }
];
